import {Calendar} from "primereact/calendar";
import {setChangedScheduler, setCompanyField} from "../../../../redux/actions/actions";
import React from "react";
import {useAppDispatch, useAppSelector} from "../../../../redux/hooks";
import moment from "moment/moment";
import {classNames} from "primereact/utils";
import {checkPermissions} from "../../../../redux/permissions/permissionsUtils";

const LaunchDate = (props: any) => {
    moment.suppressDeprecationWarnings = true;
    const dispatch = useAppDispatch();
    const companiesData = useAppSelector(state => state.CompaniesListReducer.companiesData);
    const errorFields = useAppSelector(state => state.CompaniesListReducer.errorFields);
    const statusDone = companiesData?.campaign?.statusId === 6;
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as Record<string, string[]>;
    const dialerPermissions = checkPermissions(rolesVision, 'Campaigns');
    const editType = useAppSelector(state => state.UsersReducer.editType);
    const archiveTableToggle = useAppSelector(state => state.CompaniesListReducer.archiveTableToggle);
    const {
        // create: hasCampaignsCreatePermission,
        // update: hasCampaignsUpdatePermission,
    } = dialerPermissions;
    const isValidDate = (value: any) => {
        const format = 'MM/DD/YYYY';
        return moment(value, format, true).isValid();
    };

    const handleDateChange = (date: any) => {
            return moment(date).format('MM/DD/YYYY HH:mm:ss');
    };

    const transformToDate = (dateString: any) => {
        return new Date(moment(dateString).format('MM/DD/YYYY HH:mm:ss'));
    }


    return (
        <>
            <div>
                <label htmlFor="icon" className="block field">Дата запуску</label>
                <Calendar
                    className={classNames('', {'p-invalid': errorFields?.startDate && companiesData?.scheduler?.typeScheduler === 401})}
                    value={companiesData?.scheduler?.startDate ? transformToDate(companiesData?.scheduler?.startDate) : transformToDate(props.startDate)}
                    onChange={(e: any) => {
                        if (isValidDate(e.value)) {
                            dispatch(setChangedScheduler(true));
                            dispatch(setCompanyField({section: 'scheduler', fieldName: 'startDate', value: handleDateChange(e.value)}));
                        }
                    }}
                    onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 8); // ddMMyyyy

                        const dd = digits.slice(0, 2);
                        const mm = digits.slice(2, 4);
                        const yyyy = digits.slice(4, 8);

                        const display =
                            (dd || "") +
                            (digits.length > 2 ? "/" + mm : "") +
                            (digits.length > 4 ? "/" + yyyy : "");

                        const newCaret =
                            digits.length +
                            (digits.length > 2 ? 1 : 0) +
                            (digits.length > 4 ? 1 : 0);

                        if (input.value !== display) {
                            input.value = display;
                            input.setSelectionRange(newCaret, newCaret);
                        }

                        if (digits.length === 8) {
                            const day = parseInt(dd, 10);
                            const month = parseInt(mm, 10) - 1; // 0-based
                            const year = parseInt(yyyy, 10);
                            const parsed = new Date(year, month, day);

                            const valid =
                                !isNaN(parsed.getTime()) &&
                                parsed.getDate() === day &&
                                parsed.getMonth() === month &&
                                parsed.getFullYear() === year;

                            if (valid && isValidDate(parsed)) {
                                dispatch(setChangedScheduler(true));
                                dispatch(setCompanyField({section: 'scheduler', fieldName: 'startDate', value: handleDateChange(parsed)}));
                            }
                        }
                    }}
                    onFocus={(e: any) => {
                        e.target.value = "";
                    }}
                    onBlur={(e: any) => {
                        const digits = e.target.value.replace(/\D/g, "");
                        if (digits.length !== 8) {
                            e.target.value = "";
                            const originalValue = companiesData?.scheduler?.startDate ? transformToDate(companiesData?.scheduler?.startDate) : transformToDate(props.startDate);
                            if (originalValue) {
                                e.target.value = originalValue.toLocaleDateString('en-GB');
                            }
                        }
                    }}
                    minDate={new Date()}
                    maxDate={new Date(2030, 11, 31)}
                    dateFormat="dd/mm/yy"
                    placeholder="дд/мм/рр"
                    disabled={!archiveTableToggle || statusDone || !editType}
                />
                {errorFields?.startDate && <div className="col-12 md:col-12 pt-2 px-0 pb-0"><span className="title p-error text-sm">Дата запуску не може перевищувати дату завершення.*</span></div>}
            </div>
        </>
    );
};

export default LaunchDate;
